import { writable } from "svelte/store";

type SidePanelState = {
  isOpen: boolean;
  credits: number;
  inviteToken: string | null;
};

const createSidePanelStore = () => {
  const { subscribe, set, update } = writable<SidePanelState>({
    isOpen: true,
    credits: 0,
    inviteToken: null,
  });

  return {
    subscribe,
    toggle: () => update((state) => ({ ...state, isOpen: !state.isOpen })),
    setOpen: (isOpen: boolean) => update((state) => ({ ...state, isOpen })),
    getOpen: () => subscribe((state) => state.isOpen),
    setCredits: (credits: number) => update((state) => ({ ...state, credits })),
    getCredits: () => {
      let credits = 0;
      subscribe((state) => (credits = state.credits))();
      return credits;
    },
    setInviteToken: (inviteToken: string | null) => update((state) => ({ ...state, inviteToken })),
    getInviteToken: () => subscribe((state) => state.inviteToken),
  };
};

export const sidePanelStore = createSidePanelStore();
